<template>
  <div class="UnderConstruction-container">
    <el-icon :size="60" color="#F56C6C">
      <construction-icon />
    </el-icon>
    <h1>{{ $t('message.underConstruction.title') }}</h1>
    <p>{{ $t('message.underConstruction.description') }}</p>
  </div>
</template>

<script>
import { OfficeBuilding } from '@element-plus/icons-vue'
export default {
  name: 'UnderConstruction',
  components: {
    'construction-icon': OfficeBuilding  // 使用kebab-case命名更符合Vue规范
  }
};
</script>

<style scoped>
.UnderConstruction-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  font-size: 16px;
  color: #666;
  padding: 20px;
  gap: 20px;  /* 添加元素间距 */
}

h1 {
  font-size: 2rem;
  margin: 0;
  color: #333;
}

p {
  font-size: 1.2rem;
  max-width: 600px;
  line-height: 1.6;
  margin: 0;
}
</style>